import React from 'react';
import { Card, Button, Badge, Container } from 'react-bootstrap';

const UserWelcome = ({ userData, onLogout }) => {
  if (!userData.login) {
    return null;
  }

  return (
    <Container className="py-4">
      <Card className="border-0 shadow-sm">
        <Card.Body className="text-center p-4">
          <div className="mb-4">
            <i className="bi bi-person-circle" style={{ fontSize: '3rem', color: '#143c2c' }}></i>
          </div>

          <h2 className="display-6 mb-3" style={{ color: '#143c2c' }}>
            ¡Bienvenido/a, {userData.name_user}!
          </h2>

          <div className="d-flex justify-content-center align-items-center gap-2 mb-3">
            <Badge bg="secondary" className="px-3 py-2">
              <i className="bi bi-person-vcard me-2"></i>
              DNI: {userData.dni}
            </Badge>

            {!userData.isVoted && (
              <Badge bg="success" className="px-3 py-2">
                <i className="bi bi-check-circle me-2"></i>
                Habilitado para votar
              </Badge>
            )}

            {userData.isVoted && (
              <Badge bg="info" className="px-3 py-2">
                <i className="bi bi-check-circle-fill me-2"></i>
                Voto registrado
              </Badge>
            )}
          </div>

          {!userData.isVoted && (
            <Card className="border-success mb-4">
              <Card.Body className="text-center" style={{ backgroundColor: '#f8fff8' }}>
                <i className="bi bi-info-circle-fill text-success mb-2" style={{ fontSize: '1.5rem' }}></i>
                <p className="mb-0">
                  <strong>¡Es tu momento de participar!</strong><br />
                  Podés votar por una propuesta por única vez.<br />
                  Una vez que registres tu voto ya no podrás modificarlo.
                </p>
              </Card.Body>
            </Card>
          )}

          {userData.isVoted && (
            <Card className="border-info mb-4">
              <Card.Body className="text-center" style={{ backgroundColor: '#f8f9ff' }}>
                <i className="bi bi-check-circle-fill text-info mb-2" style={{ fontSize: '1.5rem' }}></i>
                <p className="mb-0">
                  <strong>¡Gracias por participar!</strong><br />
                  Tu voto ya fue registrado correctamente.
                </p>
              </Card.Body>
            </Card>
          )}

          <Button
            variant="outline-danger"
            onClick={onLogout}
            className="px-4"
          >
            <i className="bi bi-box-arrow-right me-2"></i>
            Cerrar sesión
          </Button>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default UserWelcome;